import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Smartphone, Tablet, GlassWater, Grip, Cable, Wrench } from "lucide-react";

const MOUNTS = [
  { Icon: Smartphone, t: "Phone Mounts" },
  { Icon: Tablet, t: "Tablet Mounts" },
  { Icon: GlassWater, t: "Cup-Holder Mounts" },
  { Icon: Grip, t: "Cab Clip Mounts" },
  { Icon: Cable, t: "Strap Mounts" },
  { Icon: Wrench, t: "Machine-Specific Mounts" },
];

const EQUIP = ["Excavators", "Dozers", "Scrapers", "Loaders", "Haul Trucks", "Other Equipment"];

export default function Mounts() {
  return (
    <div className="min-h-screen bg-void">
      <Navbar />

      <section className="relative overflow-hidden border-b border-edge">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div className="relative mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-28">
          <span className="inline-block border border-yellow bg-yellow/10 px-4 py-2 font-mono text-xs font-bold uppercase tracking-widest text-yellow">
            Coming Soon
          </span>
          <h1 className="mt-6 max-w-3xl font-head text-4xl font-black uppercase leading-[0.95] tracking-tight text-gray-100 lg:text-6xl">
            GradeTrack<br />Mounting Systems
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-gray-400">
            Purpose-built mounting options for the machines and equipment you work in.
          </p>
        </div>
      </section>

      <section className="dot-bg py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <span className="font-mono text-xs font-semibold uppercase tracking-widest text-gray-500">Future mount categories</span>
          <div className="mt-8 grid gap-px border border-edge bg-edge sm:grid-cols-2 lg:grid-cols-3">
            {MOUNTS.map(({ Icon, t }) => (
              <div key={t} className="relative bg-void p-8">
                <Icon className="h-8 w-8 text-yellow" />
                <h3 className="mt-6 font-head text-xl font-bold uppercase tracking-wide text-gray-100">{t}</h3>
                <span className="absolute right-5 top-5 font-mono text-[10px] uppercase tracking-widest text-gray-600">Soon</span>
              </div>
            ))}
          </div>

          <div className="mt-16">
            <span className="font-mono text-xs font-semibold uppercase tracking-widest text-gray-500">Built for the equipment</span>
            <div className="mt-6 flex flex-wrap gap-3">
              {EQUIP.map((e) => (
                <span key={e} className="border border-edge bg-panel/70 px-5 py-3 font-head text-sm font-bold uppercase tracking-wider text-gray-300">
                  {e}
                </span>
              ))}
            </div>
          </div>

          <div className="mt-16 border border-edge bg-cardbg p-10 text-center">
            <h2 className="font-head text-3xl font-black uppercase tracking-tight text-gray-100">
              Physical mounts are <span className="text-yellow">on the way.</span>
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-gray-400">
              GradeTrack mounting systems are part of the future ecosystem — engineered to survive the cab.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
